'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

exports.isContentActionable = isContentActionable;
exports.canEditContent = canEditContent;
exports.canEditOwnEvent = canEditOwnEvent;
exports.canRedactEvent = canRedactEvent;
exports.findEditableEvent = findEditableEvent;
exports.isBridge = isBridge;
exports.getBridgeDeliveryEvent = getBridgeDeliveryEvent;
exports.getBridgeType = getBridgeType;
exports.getBridgeDeliveryState = getBridgeDeliveryState;
exports.hasBridgeSendingFailed = hasBridgeSendingFailed;

var _matrixJsSdk = require('matrix-js-sdk');

var _MatrixClientPeg = require('../MatrixClientPeg');

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _shouldHideEvent = require('../shouldHideEvent');

var _shouldHideEvent2 = _interopRequireDefault(_shouldHideEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns whether an event should allow actions like reply, reactions, edit, etc.
 * which effectively checks whether it's a regular message that has been sent and that we
 * can display.
 *
 * @param {MatrixEvent} mxEvent The event to check
 * @returns {boolean} true if actionable
 */
function isContentActionable(mxEvent) {
    var eventStatus = mxEvent.status;

    // status is SENT before remote-echo, null after

    var isSent = !eventStatus || eventStatus === _matrixJsSdk.EventStatus.SENT;

    if (isSent && mxEvent.getType() === 'm.room.message') {
        var content = mxEvent.getContent();
        if (content.msgtype && content.msgtype !== 'm.bad.encrypted' && content.hasOwnProperty('body')) {
            return true;
        }
    }

    return false;
} /*
  Copyright 2019 New Vector Ltd
  
  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  */

function canEditContent(mxEvent) {
    if (mxEvent.status === _matrixJsSdk.EventStatus.CANCELLED || mxEvent.getType() !== "m.room.message") {
        return false;
    }
    var content = mxEvent.getOriginalContent();
    var msgtype = content.msgtype;

    return (msgtype === "m.text" || msgtype === "m.emote") && content.body && typeof content.body === 'string' && mxEvent.getSender() === _MatrixClientPeg2.default.get().getUserId();
}

function canEditOwnEvent(mxEvent) {
    // for now we only allow editing
    // your own events. So this just call through
    // In the future though, moderators will be able to
    // edit other people's messages as well but we don't
    // want findEditableEvent to return other people's events
    // hence this method.
    return canEditContent(mxEvent);
}

function canRedactEvent(mxEvent) {
    var cli = _MatrixClientPeg2.default.get();
    var room = cli.getRoom(mxEvent.getRoomId());
    return room.currentState.maySendEvent("m.room.redaction", cli.credentials.userId);
}

var MAX_JUMP_DISTANCE = 100;
function findEditableEvent(room, isForward) {
    var fromEventId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    var liveTimeline = room.getLiveTimeline();
    var events = liveTimeline.getEvents().concat(room.getPendingEvents());
    var maxIdx = events.length - 1;
    var inc = isForward ? 1 : -1;
    var beginIdx = isForward ? 0 : maxIdx;
    var endIdx = isForward ? maxIdx : 0;
    if (!fromEventId) {
        endIdx = Math.min(Math.max(0, beginIdx + inc * MAX_JUMP_DISTANCE), maxIdx);
    }
    var foundFromEventId = !fromEventId;
    for (var i = beginIdx; i !== endIdx + inc; i += inc) {
        var e = events[i];
        // find start event first
        if (!foundFromEventId && e.getId() === fromEventId) {
            foundFromEventId = true;
            // don't look further than MAX_JUMP_DISTANCE events from `fromEventId`
            // to not iterate potentially 1000nds of events on key up/down
            endIdx = Math.min(Math.max(0, i + inc * MAX_JUMP_DISTANCE), maxIdx);
        } else if (foundFromEventId && !(0, _shouldHideEvent2.default)(e) && canEditOwnEvent(e)) {
            // otherwise look for editable event
            return e;
        }
    }
}

function isBridge(room) {
    if (!room) return false;

    return (0, _from2.default)(room.currentState.events.keys()).some(function (type) {
        return type === 'g.fb' || type.startsWith('g.bridge');
    });
}

function getBridgeDeliveryEvent(room, mxEvent) {
    if (!room || !room.timelineSets) return null;
    var timelineSet = room.timelineSets[0];
    if (!timelineSet) return null;

    var relation = timelineSet.getRelationsForEvent(mxEvent.getId(), "g.annotation", "g.delivery");
    if (!relation) return null;

    var deliveryEvents = relation.getRelations();

    return deliveryEvents.sort(function (a, b) {
        return b.getTs() - a.getTs();
    })[0];
}

function getBridgeType(mxEvent) {
    if (!mxEvent) return null;
    var content = mxEvent.getContent();
    if (!content["m.relates_to"]) return null;
    return content["m.relates_to"].bridge_type;
}

function isCurrentUserSender(_, mxEvent) {
    return _MatrixClientPeg2.default.get().getUserId() === mxEvent.getSender();
}

var PENDING_STATES = [_matrixJsSdk.EventStatus.ENCRYPTING, _matrixJsSdk.EventStatus.QUEUED, _matrixJsSdk.EventStatus.SENDING];
var ERROR_STATES = [_matrixJsSdk.EventStatus.CANCELLED, _matrixJsSdk.EventStatus.NOT_SENT];
function getBridgeDeliveryState(room, mxEvent) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var checkIsSender = options.checkIsSender || isCurrentUserSender;
    var isRoomBridge = isBridge(room);
    if (!mxEvent) return null;
    if (!isRoomBridge) return null;
    var isSender = checkIsSender(room, mxEvent);
    if (!isSender) return null;

    var eventStatus = mxEvent.getAssociatedStatus();
    if (PENDING_STATES.includes(eventStatus)) return 'pending';
    if (ERROR_STATES.includes(eventStatus)) return 'error';

    var _ref = mxEvent.getContent() || {},
        _ref$bridge_metadata = _ref.bridge_metadata;

    _ref$bridge_metadata = _ref$bridge_metadata === undefined ? {} : _ref$bridge_metadata;
    var _ref$bridge_metadata$ = _ref$bridge_metadata.id,
        id = _ref$bridge_metadata$ === undefined ? null : _ref$bridge_metadata$;

    if (id) {
        return 'sent';
    }

    var lastDeliveryEvent = getBridgeDeliveryEvent(room, mxEvent);

    if (!lastDeliveryEvent) {
        // In rare error cases we wont ever get a deliver event from the bridge
        // In this case we'll just assume that the event was sent after 15 minutes.
        if (new Date() - 600000 > mxEvent.getTs()) {
            return 'sent';
        }
        return 'pending';
    }
    var content = lastDeliveryEvent.getContent();

    if (!content["m.relates_to"]) return 'sent';

    return content["m.relates_to"].delivery_state;
}

function hasBridgeSendingFailed(room, mxEvent) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var deliveryStates = getBridgeDeliveryState(room, mxEvent, options);
    return deliveryStates === 'error';
}
//# sourceMappingURL=EventUtils.js.map